import type { CSSProperties } from 'react';
import type { PlanLimitHint } from './limits';
import { PLAN_LIMIT_COPY } from './limits';

// Enlace provisional a la sección de precios de la landing.
// TODO (Fase 3): pasar `onUpgrade` que llame a create-checkout-session
// para abrir el Checkout de Stripe dentro de la app.
const PRICING_URL = 'https://simplyteam.app/#precios';

export default function UpgradeBanner({
  hint,
  onUpgrade,
}: {
  hint: PlanLimitHint;
  onUpgrade?: () => void;
}) {
  const copy = PLAN_LIMIT_COPY[hint];
  return (
    <div style={s.wrap} role="alert">
      <span style={s.icon} aria-hidden>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="11" width="18" height="11" rx="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
      </span>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={s.title}>{copy.title}</div>
        <div style={s.body}>{copy.body}</div>
      </div>
      {onUpgrade ? (
        <button type="button" onClick={onUpgrade} style={s.cta}>Mejorar a Team</button>
      ) : (
        <a href={PRICING_URL} target="_blank" rel="noreferrer" style={s.cta}>Ver planes</a>
      )}
    </div>
  );
}

const s: Record<string, CSSProperties> = {
  wrap: {
    display: 'flex', alignItems: 'flex-start', gap: 12,
    background: '#eff5ff', border: '1px solid #dbe7fe', borderRadius: 12, padding: '14px 16px',
  },
  icon: { display: 'flex', color: '#2563eb', marginTop: 1, flex: 'none' },
  title: { fontSize: 14, fontWeight: 700, color: '#1e3a8a' },
  body: { fontSize: 13, color: '#1d4ed8', lineHeight: 1.5, marginTop: 2, opacity: 0.92 },
  cta: {
    background: '#2563eb', color: '#fff', border: 'none', borderRadius: 8,
    padding: '9px 14px', fontSize: 13.5, fontWeight: 600, cursor: 'pointer',
    whiteSpace: 'nowrap', textDecoration: 'none', alignSelf: 'center',
  },
};
